export default "__VITE_ASSET__DlaZrsP6__"